import { Component } from '@angular/core';

@Component({
  template: require('./app.component.html')
})
export class AppComponent {}
